var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-orange-academy-300 text-white p-4 rounded-3xl h-10 flex items-center\nfont-sans-serif"},[_vm._v(" "+_vm._s(_vm.media.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }